import SectionHeading from "@/components/SectionHeading";
import type { MembershipApplicationDetail } from "../queries";

interface Props {
  application: MembershipApplicationDetail;
}

function PhotoCircle({ src, alt, label }: { src: string | null | undefined; alt: string; label: string }) {
  return (
    <div className="flex flex-col items-center gap-2">
      {src ? (
        <img src={src} alt={alt} className="w-16 h-16 rounded-full object-cover" />
      ) : (
        <div className="w-16 h-16 rounded-full bg-sys-brand-surface-container-high flex items-center justify-center">
          <span className="text-sys-brand-on-surface-variant text-title-medium">N/A</span>
        </div>
      )}
      <span className="text-body-small text-sys-brand-on-surface-variant">{label}</span>
    </div>
  );
}

export default function ApplicantPhotoSection({ application }: Props) {
  return (
    <>
      <SectionHeading heading="Applicant Photo" body="View new applicant photo" />
      <div className="rounded-xl border border-sys-brand-outline p-6 w-full md:w-1/3">
        <div className="flex gap-6">
          <PhotoCircle src={application.profilePhotoUrl} alt="New applicant photo" label="New Photo" />
          <PhotoCircle src={application.person.profilePhoto} alt="Current photo" label="Current Photo" />
        </div>
      </div>
    </>
  );
}
